const highlightToMediaItem = highlight => {
  var _ref, _highlight$caption;
  return highlight.image.url ? {
    dataURI: highlight.image.url,
    name: (_ref = (_highlight$caption = highlight.caption) !== null && _highlight$caption !== void 0 ? _highlight$caption : highlight.title) !== null && _ref !== void 0 ? _ref : 'File'
  } : null;
};
const screenshotToMediaItem = screenshot => {
  var _screenshot$caption;
  return screenshot.image.url ? {
    dataURI: screenshot.image.url,
    name: (_screenshot$caption = screenshot.caption) !== null && _screenshot$caption !== void 0 ? _screenshot$caption : 'File'
  } : null;
};
export const getOverviewTabMediaItems = (highlights, screenshots) => {
  const highlightsMedia = highlights.map(highlight => highlightToMediaItem(highlight)).filter(highlight => highlight !== null);
  const screenshotsMedia = screenshots.map(screenshot => screenshotToMediaItem(screenshot)).filter(screenshot => screenshot !== null);
  return [...highlightsMedia, ...screenshotsMedia];
};